import { SearchOperators } from "./inventories";

export enum AuthenticationCodeType {
  SMS = 0,
  Email = 1
}

export class DatosUsuarioCliente {

  idCliente: number;
  nombreCliente: string;
  username: string;
  isDocout: boolean;
  isAdmin: boolean;
  isSupervisor: boolean;
  idioma = 'es';
  nombreUsuario: string;
  fechaUltimaVisita: Date;
  idUsuario: number;
  NotificacionesPendientesLeer: number;
  NotificacionesImportantesPendientesLeer: number;
  Inventarios: boolean;
  EmailSoporte: string;
  autorizaciones: boolean;
  preavisoExpiracionPassword: boolean;
  manual: string;
  busquedaRangoSimple: string;
  operadorBusquedaDefault: SearchOperators;
  GetContainerDetails: boolean;
  TienePermisosDevoluciones: boolean;
  isSsoAuthentication: boolean;
  canExportInventories: boolean;
  busquedaPorOficinas: boolean;
  permisoPrestamoParcial: boolean;
  permisoPuedeModificarDirecciones: boolean;
  permisoPrestamoContenedorInventario: boolean;
  isProveedorUser: boolean;
  constructor() { }

  static toModel(json: string): DatosUsuarioCliente {
    const data = JSON.parse(json);
    const toReturn = new DatosUsuarioCliente();

    toReturn.idCliente = data.ID_CLIENTE;
    toReturn.username = data.USERNAME;
    toReturn.nombreCliente = data.NOMBRE_CLIENTE;
    toReturn.isDocout = data.isDocout;
    toReturn.isSupervisor = data.isSupervisor;
    toReturn.idioma = data.IDIOMA;
    toReturn.nombreUsuario = data.NameApesUser;
    toReturn.fechaUltimaVisita = data.FechaUltimaVisita ? new Date(data.FechaUltimaVisita) : undefined;
    toReturn.idUsuario = data.ID_USUARIO;
    toReturn.NotificacionesPendientesLeer = data.NotificacionesPendientesLeer;
    toReturn.NotificacionesImportantesPendientesLeer = data.NotificacionesImportantesPendientesLeer;
    toReturn.Inventarios = data.Inventarios;
    toReturn.EmailSoporte = data.EmailSoporte;
    toReturn.isAdmin = data.isAdmin;
    toReturn.autorizaciones = data.autorizaciones;
    toReturn.preavisoExpiracionPassword = data.PreavisoExpiracionPassword;
    toReturn.manual = data.Manual;
    toReturn.busquedaRangoSimple = data.busquedaRangoSimple;
    toReturn.operadorBusquedaDefault = SearchOperators[data.operadorBusquedaDefault as string];
    toReturn.GetContainerDetails = data.GetContainerDetails;
    toReturn.TienePermisosDevoluciones = data.TienePermisosDevoluciones;
    toReturn.isSsoAuthentication = data.IsSsoAuthentication;
    toReturn.canExportInventories = data.CanExportInventories;
    toReturn.busquedaPorOficinas = data.busquedaPorOficinas;
    toReturn.permisoPrestamoParcial = data.permisoPrestamoParcial;
    toReturn.permisoPuedeModificarDirecciones = data.permisoPuedeModificarDirecciones;
    toReturn.permisoPrestamoContenedorInventario = data.permisoPrestamoContenedorInventario;
    toReturn.isProveedorUser = data.isProveedorUser;
    return toReturn;
  }

}
